import analyzeLottie from '@assets/meeting/analyze-lottie.json?url';
import palette from '@lib/core/src/theme/palette';
import { Player } from '@lottiefiles/react-lottie-player';
import { Stack, Typography } from '@mui/material';

import Sparkling from '@/assets/buttons-icons/sparkling-fill.svg?react';

const GeneratingStrategicPlan = () => {
  return (
    <Stack
      sx={{
        width: '100%',
        height: '100%',
        alignItems: 'center',
        gap: '30px'
      }}
    >
      <Sparkling />
      <Stack sx={{ gap: '4px', alignItems: 'center' }}>
        <Typography sx={{ fontSize: '16px' }}>Generating strategic plan</Typography>
        <Typography sx={{ fontSize: '13px', color: palette.grey[500] }}>
          This may take 1-2 minutes. hold tight!
        </Typography>
      </Stack>

      <Player src={analyzeLottie} loop autoplay />
    </Stack>
  );
};

export default GeneratingStrategicPlan;
